import { useParams } from 'react-router-dom';
import moment from "moment-timezone"
import { useState, useRef } from "react";
import jsPDF from "jspdf";//"jspdf": "^4.1.0",
import autoTable from "jspdf-autotable";//"jspdf-autotable": "^5.0.7",
import { ACCORDIAN_TITLE, ACTION_STATUS, connectionOptions, currencyOptions, grxTransportOptions } from './constants/DemandConstant';
import IMAGES from '../assets/images/images';
import { downloadFileStream } from '../api/uploadAttachment/attachment.service';

export const customGroupBy = (array, key) => {
  return array.reduce((acc, currentValue) => {
    let groupKey = currentValue[key]
    if (!acc[groupKey]) {
      acc[groupKey] = []
    }
    acc[groupKey].push(currentValue)
    return acc
  }, {})
}

export const getLabelFromValue = (array, value) => {
  var result = array?.find((item) => item?.value === value)
  return result?.label
}

export const formatDate = (unixTimestamp) => {
  const userTimezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone
  const formattedDate = moment
    .unix(unixTimestamp)
    .tz(userTimezone)
    .format("DD MMM YYYY HH:mm")
  const timezoneAbbr = moment.tz(userTimezone).zoneAbbr()
  return `${formattedDate} ${timezoneAbbr}`
}
export const formatDateDDMMM = (unixTimestamp) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formattedDate = moment
    .unix(unixTimestamp)
    .tz(userTimezone)
    .format("DD MMMM")
  return `${formattedDate}`
}
export const futureDate = (unixTimestamp) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const futureTimestamp = moment.unix(unixTimestamp).add(360, "hours") //oneitsm_api_integration; Interim : 2 days=>48 and oneITSM 15 days=>360
  return futureTimestamp.tz(userTimezone).format("DD MMM")
}

export const dueDate = (unixTimestamp) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const futureTimestamp = moment.unix(unixTimestamp).add(10, "days")
  return futureTimestamp.tz(userTimezone).format("DD MMM")
}

export const convertToTimestampObject = (dateTimeString) => {
  if (!dateTimeString) {
    return null
  }
  const timezone = moment.tz.guess()
  const timestamp = moment.utc(dateTimeString)?.unix()
  return {
    timestamp: timestamp,
    timezone: timezone
  }
}

export function extractJson(errorMessage) {
  const regex = /{.*}/
  const match = errorMessage.match(regex)
  if (match) {
    const jsonString = match[0]
    try {
      return JSON.parse(jsonString)
    } catch (error) {
      console.error("Failed to parse JSON:", error)
      return null
    }
  }
}

export const filterAndMapIds = (data, itemId) => {
    return data?.reduce((acc, row) => {
        if (row?.detailsId === itemId) {
            acc.push(row?.id);
        }
        return acc;
    }, []);
};

export const isWidgetPresent = (widgetDetails, widgetName) => {
    return widgetDetails?.some(widget => widget?.widgetName === widgetName);
};
    
export const dashboardTime = (unixTimestamp) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formattedDate = moment
    .unix(unixTimestamp)
    .tz(userTimezone)
    .format("DD MMM YYYY")
  return `${formattedDate}`
}
export const sortByLabelAsc = (options) => {
  if (!Array.isArray(options)) return [];
  return [...options].sort((a, b) => a.label.localeCompare(b.label));
};

export const getLocationDetails=(popData,router)=>{
  const obj = popData.find(({ siteCodeKey }) => router?.toLowerCase().trim().startsWith(siteCodeKey?.toLowerCase().trim()))
  return obj;
}


export const getTimezoneLabel=(timezone) =>{
  if (!moment.tz.zone(timezone)) {
    return '';
  }
  return `In ${moment().tz(timezone).format('z')}`|| '';
}

export const useNotificationId = () => {
  const { data } = useParams();
  const raw =  data;
  if (!raw) return null;
  try {
    const decoded = JSON.parse(decodeURIComponent(raw));
    return decoded.notificationId || null;
  } catch (error) {
    console.error("Failed to decode notificationId:", error);
    return null;
  }
};


// Common Functionality for passwordResetAttempts
const STORAGE_KEY = 'forgotPasswordAttempts';
const MAX_ATTEMPTS = 3;
const LOCKOUT_TIME = 30 * 60 * 1000; // 30 minutes

export function getAttempts() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {
    count: 0,
    firstAttemptTime: null,
    secondAttemptTime: null,
    thirdAttemptTime: null,
  };
}

export function resetAttempts() {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ count: 0, firstAttemptTime: null, secondAttemptTime: null, thirdAttemptTime: null })
  );
}

export function isLockedOut() {
  const attempts = getAttempts();
  const currentTime = Date.now();

  if (attempts.count >= MAX_ATTEMPTS && currentTime - attempts.thirdAttemptTime < LOCKOUT_TIME) {
    return true;
  }

  // Reset if lockout expired
  if (attempts.firstAttemptTime && currentTime - attempts.firstAttemptTime > LOCKOUT_TIME) {
    resetAttempts();
    return false;
  }

  return false;
}

export function recordAttempt() {
  const attempts = getAttempts();
  const currentTime = Date.now();

  attempts.count += 1;
  if (attempts.count === 1) attempts.firstAttemptTime = currentTime;
  else if (attempts.count === 2) attempts.secondAttemptTime = currentTime;
  else if (attempts.count === 3) attempts.thirdAttemptTime = currentTime;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(attempts));
}

//get default last 3 month range
export const getLastThreeMonths = () => {
  const today = new Date();
  const months = [];
  for (let i = 2; i >= 0; i--) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    months.push(`${year}-${month}`);
  }
  const startDate = new Date(months[0]);
  const endDate = new Date(months[months.length - 1]);
  const startMonthName = startDate.toLocaleString("default", { month: "long" });
  const endMonthName = endDate.toLocaleString("default", { month: "long" });
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  const customLabel = `${startMonthName} ${startYear} - ${endMonthName} ${endYear}`;
  return {
    label: `${customLabel}`,
    value: months,
  };
};

export const extractYearFromValue = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    return parseInt(value[0]?.split("-")[0], 10);
  } else if (typeof value === "string" && value.length > 0) {
    return parseInt(value?.split("-")[0], 10);
  }
  return new Date().getFullYear();
};
const OPTIONS = { SINGLE: "Single", MULTIPLE: "Multiple"}; 
export const determineSelectionType = (value) => {
  if (Array.isArray(value)) {
    return value.length === 1 ? OPTIONS.SINGLE : OPTIONS.MULTIPLE;
  }
  return OPTIONS.SINGLE;
};


export function computeWeightedWidths(columns, defaultWeight = 1) {
  const total = columns.reduce((sum, c) => sum + (c.weight ?? defaultWeight), 0);
  return columns.map(c => ({ ...c,
    width: `${(((c.weight ?? defaultWeight) / total) * 100).toFixed(3)}%`,
  }));
}

export function usePopupPosition(filterWidth = 300) {
  const [position, setPosition] = useState(null);
  const columnRef = useRef(null);
  const iconRef = useRef(null);

  const calculatePosition = () => {
    if (!columnRef.current || !iconRef.current) return;
    const columnRect = columnRef.current.getBoundingClientRect();
    const iconRect = iconRef.current.getBoundingClientRect();
    const spaceOnLeft = iconRect.left - columnRect.left;

    if (spaceOnLeft >= filterWidth) {
      setPosition("left");
    } else {
      setPosition("right");
    }
  };
  return { position, columnRef, iconRef, calculatePosition };
}
//Pdf-logic
// Safe string for filename
const safe = (str) => (str ?? "").toString().replace(/[^\w \-().:/@]+/g, "_");
// Convert imported image / URL to Base64 usable by jsPDF
async function toBase64(url,maxWidth = 220) {
  if (!url) return null;
  if (String(url).startsWith("data:image")) {
    return { data: url, pxW: maxWidth, pxH: maxWidth, format: "PNG" };
  }
  return new Promise((resolve) => {
    const img = new Image();
      img.crossOrigin = "Anonymous";

    img.onload = () => {
      let w = img.naturalWidth;
      let h = img.naturalHeight;
      if (w > maxWidth) {
        const ratio = maxWidth / w;
        w = Math.round(w * ratio);
        h = Math.round(h * ratio);
      }
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      const data = canvas.toDataURL("image/png");

      resolve({data,pxW: w,pxH: h,format: "PNG",});
    };

    img.onerror = () => resolve(null);
    img.src = url;
  });
}

export async function generateQuotationPDF(values,setDownloading,regionOptions,options = {}) {
  setDownloading(true);
  const {title = "Quotation",confidentialityNote ="This offer is to be kept strictly confidential between the parties and subject to final commercial approval.",} = options;
  /* -------------------- SETUP -------------------- */
  const pdf = new jsPDF("p", "mm", "a4");
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const MARGIN = 12;
  const CONTENT_W = pageW - 2 * MARGIN;

  const FIRST_PAGE_HEADER_H = 34;
  const FIRST_PAGE_TOP = FIRST_PAGE_HEADER_H + 10;
  const OTHER_PAGE_TOP = 14;

  const FOOTER_SAFE_SPACE = 18;
  const FOOTER_DRAW_HEIGHT = 8;

  let cursorY = FIRST_PAGE_TOP;

  const logo = await toBase64(IMAGES.logo);
  const badge = IMAGES.badge ? await toBase64(IMAGES.badge) : null;
  const selectedCurrency = currencyOptions.find((c) => c.value === values.currency);
  const currencySymbol = selectedCurrency?.symbol || "---";

  /* -------------------- HELPERS -------------------- */
  function drawImagePreserveRatio(img, x, y, targetW) {
    const ratio = img.pxH / img.pxW;
    const targetH = targetW * ratio;
    pdf.addImage(img.data, img.format || "PNG", x, y, targetW, targetH);
  }

  function ensureSpace(requiredHeight = 10) {
    const limit = 
    pageH - (FOOTER_SAFE_SPACE + FOOTER_DRAW_HEIGHT);
    if (cursorY + requiredHeight > limit) {
      pdf.addPage();
      cursorY = OTHER_PAGE_TOP;
    }
  }

  /* -------------------- HEADER (PAGE 1 ONLY) -------------------- */
  function pdfFirstPageHeader() {
    if (pdf.internal.getCurrentPageInfo().pageNumber !== 1) return;
    const RED_H = 26;
    const RADIUS = RED_H / 2;
    const RED_W = pageW * 0.62;
    const RECT_W = RED_W - RADIUS;
    const RECT_X = pageW - RECT_W;

    if (badge?.data) {drawImagePreserveRatio(badge, 8, 3, 26);}

    pdf.setFillColor(230, 0, 0);
    pdf.circle(RECT_X, RADIUS, RADIUS, "F");
    pdf.rect(RECT_X, 0, RECT_W, RED_H, "F");

    if (logo?.data) {
      pdf.addImage(logo.data, "PNG", RECT_X - 8, 4, 18, 18);
    }

    pdf.setTextColor(255);
    pdf.setFont("helvetica", "bold").setFontSize(16);
    pdf.text(title, RECT_X + 18, 10);

    pdf.setFont("helvetica", "normal").setFontSize(9);
    pdf.text("Vodafone", RECT_X + 18, 16);

    pdf.setTextColor(40);
  }
  /* -------------------- FOOTER -------------------- */
  function pdfFooter() {
    const page = pdf.internal.getCurrentPageInfo().pageNumber;
    const total = pdf.internal.getNumberOfPages();
    const y = pageH - FOOTER_DRAW_HEIGHT + 2;

    if (logo?.data) pdf.addImage(logo.data, "PNG", MARGIN, y - 6, 7, 7);

    pdf.setFont("helvetica", "italic").setFontSize(8);
    pdf.setTextColor(120);
    const noteW = pdf.getTextWidth(confidentialityNote);
    pdf.text(confidentialityNote, (pageW - noteW) / 2, y);

    const pageText = `${page} / ${total}`;
    pdf.text(pageText,pageW - MARGIN - pdf.getTextWidth(pageText),y);
  }

  /* -------------------- TABLE BASE -------------------- */
  const tableBase = {
    margin: {left: MARGIN,right: MARGIN,top: OTHER_PAGE_TOP,bottom: FOOTER_SAFE_SPACE + FOOTER_DRAW_HEIGHT},
    tableWidth: CONTENT_W,
    styles: {font: "helvetica",
      fontSize: 9,
      cellPadding: 2.5,
      textColor: 40,
      lineColor: 80,
      lineWidth: 0.2,
      valign: "middle",
    },
    headStyles: {
      fontStyle: "bold",
      fillColor: false,
      halign: "left",
    },
    alternateRowStyles: { fillColor: false },
    didDrawPage: () => {
      pdfFirstPageHeader();
      pdfFooter();
    },
  };

  /* -------------------- SUMMARY -------------------- */

  ensureSpace(20);

  [
    ["Customer Name", values.customerLegalName || "--"],
    ["Created On", formatDateInDMY(values?.createdAt) || "--"],
    ["Offer Valid Till", formatDateInDMY(values?.offerValidTill) || "--"],
    [
      "Minimum Contract Period",
      values.minimumContractPeriod
        ? `${values.minimumContractPeriod} Months`
        : "--",
    ],
    ["Currency", getLabelFromValue(currencyOptions, values.currency) || "--"],
  ].forEach(([label, value]) => {
    ensureSpace(6);

    pdf.setFont("helvetica", "bold").setFontSize(9.5);
    pdf.text(label, MARGIN, cursorY);
    pdf.text(":", MARGIN + 60, cursorY);

    pdf.setFont("helvetica", "normal");
    pdf.text(value, MARGIN + 65, cursorY);

    cursorY += 6;
  });

  cursorY += 6;
  /* -------------------- SERVICE CONFIGURATION -------------------- */

  ensureSpace(10);
  pdf.setFont("helvetica", "bold").setFontSize(10.5);
  pdf.text("Service Configuration", MARGIN, cursorY);
  cursorY += 6;

  /* -------- IPX Access Standard Connection -------- */
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPASC, colSpan: 2 }]],
    body: [[
      "Connection to Vodafone standard PoPs",
      getLabelFromValue(
        connectionOptions,
        values.serviceConfig?.ipAccessStandardConnection?.connectionStatus
      ) || "--",
    ]],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
    pageBreak: "auto",
    rowPageBreak: "auto",
  });
  cursorY = pdf.lastAutoTable.finalY + 6;

  /* -------- PoPs DETAILS -------- */
  const pops = values.serviceConfig?.ipAccessStandardConnection?.popsDetails || [];
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["PoPs Detail", "Region", "Port Size (in GBPS)"]],
    body: pops.length
      ? pops.map((p, i) => [
          `PoP - ${i + 1}`,
          getLabelFromValue(regionOptions, p.region) || "--",
          p.portSize || "--",
        ])
      : [[{ content: "No PoPs configured", colSpan: 3 }]],
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: CONTENT_W - 100 },
      2: { cellWidth: 60 },
    },
    pageBreak: "auto",
    rowPageBreak: "auto",
  });

  cursorY = pdf.lastAutoTable.finalY + 6;

  /* -------- IPX / GRX TRANSPORT -------- */
  const bwRows =
    values.serviceConfig?.IpxGrxTransport?.bandwidths || [];
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPX_GRX_TRANSPORT, colSpan: 2 }]],
    body: [
      [
        ACCORDIAN_TITLE.IPX_GRX_TRANSPORT,
        getLabelFromValue(
          grxTransportOptions,
          values.serviceConfig?.IpxGrxTransport?.isIpxGrxTransport
        ) || "--",
      ],
      ...(values.serviceConfig?.IpxGrxTransport?.isIpxGrxTransport === "yes"
        ? bwRows.map((bw) => ["Bandwidth", bw.allocatedBandwidth || "--"])
        : []),
    ],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
  });
  cursorY = pdf.lastAutoTable.finalY + 6;

  /* -------- IPX SIGTRAN -------- */
  const msuRows = values.serviceConfig?.IpxSigtran?.msus || [];
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPX_SIGTRAN, colSpan: 2 }]],
    body: [
      [
        ACCORDIAN_TITLE.IPX_SIGTRAN,
        getLabelFromValue(
          grxTransportOptions,
          values.serviceConfig?.IpxSigtran?.isIpxSigtran
        ) || "--",
      ],
      ...(values.serviceConfig?.IpxSigtran?.isIpxSigtran === "yes"
        ? msuRows.map((m) => ["MSUs", m.allocatedMsus || "--"])
        : []),
    ],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
  });
  cursorY = pdf.lastAutoTable.finalY + 6;

  /* -------- IPX DIAMETER -------- */
  const trxRows =
    values.serviceConfig?.IpxDiameter?.numberOfTransactions || [];
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPX_DIAMETER, colSpan: 2 }]],
    body: [
      [
        ACCORDIAN_TITLE.IPX_DIAMETER,
        getLabelFromValue(
          grxTransportOptions,
          values.serviceConfig?.IpxDiameter?.isIpxDiameter
        ) || "--",
      ],
      ...(values.serviceConfig?.IpxDiameter?.isIpxDiameter === "yes"
        ? trxRows.map((t) => ["Transactions", t.transaction || "--"])
        : []),
    ],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
  });

  cursorY = pdf.lastAutoTable.finalY + 6;

   /* -------- IPX Http2 -------- */
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPX_HTTP, colSpan: 2 }]],
    body: [
      [
        ACCORDIAN_TITLE.IPX_HTTP,
        getLabelFromValue(
          grxTransportOptions,
          values.serviceConfig?.IpxHttp?.isIpxHttp
        ) || "--",
      ],
      ...(values.serviceConfig?.IpxHttp?.isIpxHttp === "yes"
        ? (values.serviceConfig?.IpxHttp?.transactionVolumes || []).map(
            (t) => ["Transaction Volumes", t.allocatedTransactionVolumes || "--"]
          )
        : []),
    ],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
  });
  cursorY = pdf.lastAutoTable.finalY + 6;

  /* -------- IPX DNS -------- */
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[{ content: ACCORDIAN_TITLE.IPX_DNS, colSpan: 2 }]],
    body: [[
      ACCORDIAN_TITLE.IPX_DNS,
      getLabelFromValue(
        grxTransportOptions,
        values.serviceConfig?.IsIpxDns
      ) || "--",
    ]],
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: CONTENT_W - 80 },
    },
  });
  cursorY = pdf.lastAutoTable.finalY + 8;

  /* -------------------- QUOTATION TABLE -------------------- */
  const rows = values.quotation?.rows || [];
  ensureSpace(10);
  pdf.setFont("helvetica", "bold").setFontSize(10.5);
  pdf.text(title, MARGIN, cursorY);
  cursorY += 6;
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [[
      "IPX Services",
      `Setup / Implementation fee (${currencySymbol})`,
      `Monthly Charges (${currencySymbol})`,
      `Usage Based (${currencySymbol})`
    ]],
    body: rows.map((r) => [
      r.ipxService || "--",
      r.setupCost || "--",
      r.monthlyCharges || "--",
      r.usageBased || "--",
    ]),
    tableWidth: 'auto',
    pageBreak: "auto",
    rowPageBreak: "auto",
  });

  cursorY = pdf.lastAutoTable.finalY + 8;

  /* -------------------- SAVE -------------------- */
  pdf.save(
    `${values.customerLegalName || "Customer"}_${new Date()
      .toISOString()
      .slice(0, 10)}_${title}.pdf`
  );

  setDownloading(false);
}

export function iconForStageLabel(label, iconMap) {
  const key = label
    .toLowerCase()
    .replace(/\s+/g, '')          // remove spaces
    .replace(/[-_]/g, '');        // remove dashes/underscores

  // Map to known keys
  const map = {
    demand: 'demand',
    quotation: 'quotation',
    orderform: 'orderForm',
    servicebuilding: 'serviceBuilding',
    billingonboarding: 'billingOnboarding',
    golive: 'goLive',
  };

  const resolved = map[key];
  return resolved ? iconMap[resolved] : undefined;
}

// export function buildProgressFromStates(workflowStages, currentState) {
//   // Build a flattened sequence of all states in order, preserving stage boundaries
//   const flat = [];
//   workflowStages.forEach((s, stageIndex) => {
//     s.states.forEach((st, idxInStage) => {
//       flat.push({ stageIndex, state: st, idxInStage });
//     });
//   });

//   // Find the global index of the current state (if not found => 0% everywhere)
//   const currentGlobalIndex = flat.findIndex(x => x.state === currentState);

//   // If no match, we treat everything as 0% (or you can choose to treat as full if beyond last)
//   const reachedGlobalIndex = currentGlobalIndex >= 0 ? currentGlobalIndex : -1;

//   // Count reached states per stage
//   const reachedCountByStage = new Map();
//   flat.forEach((item, globalIndex) => {
//     const reached = globalIndex <= reachedGlobalIndex;
//     if (!reachedCountByStage.has(item.stageIndex)) {
//       reachedCountByStage.set(item.stageIndex, 0);
//     }
//     if (reached) {
//       reachedCountByStage.set(item.stageIndex, reachedCountByStage.get(item.stageIndex) + 1);
//     }
//   });

//   // Which stage is active (contains currentState)?
//   const activeStageIndex = currentGlobalIndex >= 0 ? flat[currentGlobalIndex].stageIndex : -1;

//   // Prepare output per stage
//   return workflowStages.map((s, i) => {
//     const total = s.states.length || 0;
//     const reached = reachedCountByStage.get(i) || 0;

//     // percent complete strictly within the stage
//     const percent = total === 0 ? 0 : Math.min(100, Math.round((reached / total) * 100));

//     // List reached states for potential tooltip or checklist
//     const reachedStates = s.states.slice(0, reached);

//     return {
//       id: i + 1,
//       label: s.stage,
//       percentComplete: percent,
//       isActive: i === activeStageIndex,
//       reachedStates,
//       totalStates: total
//     };
//   });
// }
export function buildProgressFromStates(workflowStages, currentStateOrg, actionStatusOrg,demandClosureData={}) {
  // Map of marker -> sequence to prepend/include when that marker appears in a stage
  let currentState = currentStateOrg
  let actionStatus = actionStatusOrg

  if([ACTION_STATUS.DEMAND_CLOSED,ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM].includes(actionStatusOrg) && demandClosureData?.state && demandClosureData?.actionStatus){
    currentState = demandClosureData?.state
    actionStatus = demandClosureData?.actionStatus
  }
 
  const ActionStatus = {
    FEASIBILITY_COMPLETED: ['FEASIBILITY_INITIATED', 'FEASIBILITY_COMPLETED'],
    ORDER_FORM_DRAFTED: ['ORDER_FORM_CREATION_INITIATED', 'ORDER_FORM_DRAFTED'],
    SERVICE_PROVISIONING_COMPLETED:["PROVSIONING_INITIATED","SERVICE_PROVISIONING_COMPLETED"],
    BILLING_ONBOARDING_COMPLETED:["BILLING_INITIATED","BILLING_ONBOARDING_COMPLETED"],
  };

  // Set of all statuses we consider "priority" (if actionStatus is any of these, prefer it)
  const PRIORITY_STATUS = new Set(
    Object.values(ActionStatus).flat()
  );

  // Expand each stage if it contains any key present in ActionStatus
  const updatedWorkflowStages = workflowStages?.map((stage) => {
    // Find which keys from ActionStatus are present in this stage's states
    const keysInStage = stage.states?.filter((s) => Object.prototype.hasOwnProperty.call(ActionStatus, s));

    if (keysInStage.length === 0) {
      return stage; // No expansion needed
    }

    // Gather expansions from all matched keys
    const expansions = keysInStage.flatMap((k) => ActionStatus[k]);

    // Merge expansions + original states, dedupe while preserving order
    const seen = new Set();
    const mergedStates = [...expansions, ...stage.states].filter((s) => {
      if (seen.has(s)) return false;
      seen.add(s);
      return true;
    });

    return { ...stage, states: mergedStates };
  });

  // Flatten updated stages to a single list for indexing
  const flat = [];
  updatedWorkflowStages?.forEach((s, stageIndex) => {
    s.states?.forEach((st, idxInStage) => {
      flat.push({ stageIndex, state: st, idxInStage });
    });
  });

  // Decide which state to search for: prefer actionStatus if it is in our priority set
  const targetState =
    actionStatus && PRIORITY_STATUS.has(actionStatus) ? actionStatus : currentState;

  const currentGlobalIndex = flat.findIndex((x) => x.state === targetState);
  const reachedGlobalIndex = currentGlobalIndex >= 0 ? currentGlobalIndex : -1;

  // Count reached items per stage
  const reachedCountByStage = new Map();
  flat.forEach((item, globalIndex) => {
    if (!reachedCountByStage.has(item.stageIndex)) {
      reachedCountByStage.set(item.stageIndex, 0);
    }
    if (globalIndex <= reachedGlobalIndex) {
      reachedCountByStage.set(
        item.stageIndex,
        (reachedCountByStage.get(item.stageIndex) || 0) + 1
      );
    }
  });

  // Which stage is active?
  const activeStageIndex =
    currentGlobalIndex >= 0 ? flat[currentGlobalIndex].stageIndex : -1;
  // Return using the UPDATED stages
  return updatedWorkflowStages?.map((s, i) => {
    const total = s.states.length|| 0;
    const reached = reachedCountByStage.get(i) || 0;

    const percent =
      total === 0 ? 0 : Math.min(100, Math.round((reached / total) * 100));

    const reachedStates = s.states.slice(0, reached);

    return {
      id: i + 1,
      label: s.stage,
      percentComplete: percent,
      isActive: i === activeStageIndex,
      reachedStates,
      totalStates: total,
    };
  });
}

/** checks if a single action is present */
export const has = (allowedActions = [], actionId) => {
  if (!Array.isArray(allowedActions)) return false;
  return allowedActions.includes(actionId);
};

/** checks if ANY of the provided actions are present */
export const hasAny = (allowedActions = [], actionList = []) => {
  if (!Array.isArray(allowedActions)) return false;
  return actionList.some(action => allowedActions.includes(action));
};

export const isStateValid =(mappedStates, stage, demandDetail) => {
  const stageObj = mappedStates?.find(s => s.stage === stage);
  if (!stageObj) return false;  // stage not found
  return stageObj?.states?.includes(demandDetail?.state);
}

function normalizePdfText(text = "") {
  return String(text)
    // replace ALL special hyphens with standard ASCII hyphen
    .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, "-")
    // remove zero-width / invisible chars
    .replace(/[\u200B-\u200D\uFEFF]/g, "");
}

export async function generateOrderFormPDF(values, opts = {}) {
  const {
    logoSrc,
    badgeSrc,
    confidentialityNote = "This document is confidential and subject to contract.",
    fileName = `OrderForm_IPX_${values?.customerName || "Customer"}.pdf`,
  } = opts;

  /* ===================== SETUP ===================== */
  const pdf = new jsPDF("p", "mm", "a4");
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const MARGIN = 12;
  const CONTENT_W = pageW - MARGIN * 2;

  const FIRST_PAGE_HEADER_H = 34;
  const FIRST_PAGE_TOP_Y = FIRST_PAGE_HEADER_H + 6;
  const OTHER_PAGE_TOP_Y = 20;
  const FOOTER_SAFE_Y = pageH - 20;

  const GAP_SMALL = 4;
  const GAP_MEDIUM = 6;
  const GAP_LARGE = 10;

  let cursorY = FIRST_PAGE_TOP_Y;

  const logo = logoSrc ? await toBase64(logoSrc) : null;
  const badge = badgeSrc ? await toBase64(badgeSrc) : null;

  const safe = v => (v === 0 ? "0" : v ?? "--");

  /* ===================== PAGE GUARD ===================== */
  function ensureSpace(requiredHeight = 20) {
    if (cursorY + requiredHeight > FOOTER_SAFE_Y) {
      pdf.addPage();
      const pageNo = pdf.internal.getCurrentPageInfo().pageNumber;
      cursorY = pageNo === 1 ? FIRST_PAGE_TOP_Y : OTHER_PAGE_TOP_Y;
    }
  }

  function drawImagePreserveRatio(img, x, y, targetW) {
    const ratio = img.pxH / img.pxW;
    const targetH = targetW * ratio;
    pdf.addImage(img.data, img.format || "PNG", x, y, targetW, targetH);
    return targetH;
  }

  /* ===================== HEADER (PAGE 1 ONLY) ===================== */
  function pdfFirstPageHeader() {
    if (pdf.internal.getCurrentPageInfo().pageNumber !== 1) return;

    const RED_H = 26;
    const R = RED_H / 2;
    const RED_W = pageW * 0.62;
    const RECT_W = RED_W - R;
    const RECT_X = pageW - RECT_W;

    // if (badge?.data) pdf.addImage(badge.data, "PNG", 8, 2, 28, 22);
    if (badge?.data) {drawImagePreserveRatio(badge, 8, 3, 26);}

    pdf.setFillColor(230, 0, 0);
    pdf.circle(RECT_X, R, R, "F");
    pdf.rect(RECT_X, 0, RECT_W, RED_H, "F");

    if (logo?.data) pdf.addImage(logo.data, "PNG", RECT_X - 8, 4, 18, 18);

    pdf.setFont("helvetica", "bold").setFontSize(16);
    pdf.setTextColor(255);
    pdf.text("Order Form", RECT_X + 18, 10);

    pdf.setFont("helvetica", "normal").setFontSize(9);
    pdf.text("Vodafone", RECT_X + 18, 16);
    // pdf.text("Vodafone Procurement & Connectivity Co.", RECT_X + 18, 16);
    // pdf.text("Luxembourg", RECT_X + 18, 21);

    pdf.setTextColor(40);
  }

  /* ===================== FOOTER (ALL PAGES) ===================== */
  function pdfFooter() {
    const page = pdf.internal.getCurrentPageInfo().pageNumber;
    const total = pdf.internal.getNumberOfPages();
    const y = pageH - 7;

    if (logo?.data) pdf.addImage(logo.data, "PNG", MARGIN, y - 5, 7, 7);

    pdf.setFont("helvetica", "italic").setFontSize(9);
    pdf.setTextColor(120);
    pdf.text(confidentialityNote, (pageW - pdf.getTextWidth(confidentialityNote)) / 2, y);

    const pageText = `${page} / ${total}`;
    pdf.text(pageText, pageW - MARGIN - pdf.getTextWidth(pageText), y);
  }

  /* ===================== TABLE BASE ===================== */
  const tableBase = {
    margin: { left: MARGIN, right: MARGIN },
    tableWidth: CONTENT_W,
    styles: {font: "helvetica",fontSize: 9,cellPadding: 2.5,textColor: 40,lineColor: 80,lineWidth: 0.2,valign: "middle",},
    headStyles: {fontStyle: "bold",fillColor: false,halign: "left",lineWidth: 0.2,lineColor: 80},
    alternateRowStyles: {fillColor: false},
    didDrawPage: () => {
      pdfFirstPageHeader();
      pdfFooter();
    },
  };

  const afterTable = gap => {
    cursorY = pdf.lastAutoTable.finalY + gap;
  };

  const section = title => {
    ensureSpace(12);
    pdf.setFont("helvetica", "bold").setFontSize(9.8);
    pdf.setTextColor(60);
    pdf.text(title, MARGIN, cursorY);
    cursorY += GAP_SMALL;
  };

  const textBlock = text => {
    ensureSpace(24);
    autoTable(pdf, {
      ...tableBase,
      startY: cursorY,
      theme: "plain",
      body: [[safe(text)]],
      // styles: { cellPadding: 0, lineWidth: 0 },
      styles: {
        fontSize: 9,
        textColor: 70,
        cellPadding: 0,
        lineWidth: 0,
      },
    });
    afterTable(GAP_MEDIUM);
  };

  const noteBlock = (text) => {
    ensureSpace(16);

    autoTable(pdf, {
      ...tableBase,
      startY: cursorY,
      theme: "plain",
      body: [[`Note: ${safe(text)}`]],
      styles: {
        font: "helvetica",
        fontStyle: "italic",
        fontSize: 8,
        textColor: 40,
        cellPadding: 2,
      },
      willDrawCell: (data) => {
        if (data.section === "body") {
          pdf.setFillColor(220, 235, 255);
          const radius = 1;
          pdf.roundedRect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            radius,
            radius,
            "F"
          );
        }
      },
    });

    afterTable(GAP_SMALL);
  };

  /* ===================== TITLE ===================== */
  autoTable(pdf, {
    startY: cursorY,
    theme: "plain",
    margin: { left: MARGIN, right: MARGIN },
    body: [[
      "This Order Form includes and is governed by the terms and conditions in an Agreement — MSA/IPX Service Terms."
    ]],
    styles: {
      font: "helvetica",
      fontStyle: "normal",
      fontSize: 9,
      textColor: 70,
      cellPadding: 0,
      lineWidth: 0,
    }
  });
  cursorY = pdf.lastAutoTable.finalY + 10;

  /* ===================== SUMMARY ===================== */
  {
    const labelX = MARGIN;
    const colonX = MARGIN + 60;
    const valueX = colonX + 4;

    [
      ["Vodafone Entity", values?.vfPartyName],
      ["Organisation Name", values?.customerName],
      ["Agreement – MSA/IPX Service Status",
        values?.agreementStatus?.signedDate
          ? `Signed on ${formatDateInDMY(values.agreementStatus.signedDate)}`
          : "To Be Signed"
      ],
      ["Created On", formatDateInDMY(values?.createdAt)],
    ].forEach(([l, v]) => {
      ensureSpace(6);
      pdf.setFont("helvetica", "bold").setFontSize(9.2);
      pdf.text(l, labelX, cursorY);
      pdf.text(":", colonX, cursorY);
      pdf.setFont("helvetica", "normal");
      pdf.text(String(v ?? "--"), valueX, cursorY);
      cursorY += 6;
    });
    cursorY += 4;
  }

  /* ===================== LEGAL NOTE ===================== */
  ensureSpace(16);
  const note =
    "Until the carrier agreement is signed, the carrier general terms and IPX service terms (Sales) apply, available at https://www.vodafone.com/business/carrier-terms. These terms will be replaced with the terms and conditions set out in the carrier agreement once countersigned.";
  const link = "https://www.vodafone.com/business/carrier-terms";

  pdf.setFont("helvetica", "normal").setFontSize(9);
  pdf.setTextColor(40);

  const lines = pdf.splitTextToSize(note, CONTENT_W);
  lines.forEach(line => {
    if (line.includes(link)) {
      const [before, after] = line.split(link);
      if (before) pdf.text(before, MARGIN, cursorY);

      const bw = pdf.getTextWidth(before || "");
      pdf.setTextColor(0, 0, 200);
      pdf.textWithLink(link, MARGIN + bw, cursorY, { url: link });

      const lw = pdf.getTextWidth(link);
      pdf.setDrawColor(80);
      pdf.line(MARGIN + bw, cursorY + 0.8, MARGIN + bw + lw, cursorY + 0.8);

      if (after) {
        pdf.setTextColor(60);
        pdf.text(after, MARGIN + bw + lw, cursorY);
      }
    } else {
      pdf.text(line, MARGIN, cursorY);
    }
    cursorY += 5;
  });

  cursorY += 5;

  /* ===================== CONTENT ===================== */
  //1
  section("Requested Service Commencement Date");
  textBlock(values?.commencementDate);
  afterTable(GAP_LARGE);
  //2
  section("Minimum Term (In Months)");
  noteBlock("Bandwidth capacity to be reviewed and upgraded where necessary in accordance with the terms and conditions of the underlying agreements.");
  textBlock(values?.termMonths);
  // cursorY -= 3;
  // noteBlock("Bandwidth capacity to be reviewed and upgraded where necessary in accordance with the terms and conditions of the underlying agreements.");
  afterTable(GAP_LARGE);
  //3
  section("Contact Information");
  textBlock(values?.technicalContact);
  section("Account Manager");
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["Name", "Title", "Mobile", "Email"]],
    body: [[
      safe(values?.accountManager?.name),
      safe(values?.accountManager?.title),
      safe(values?.accountManager?.mobile),
      safe(values?.accountManager?.email),
    ]],
  });
  afterTable(GAP_LARGE);
  //4
  section("Service Offering");
  noteBlock("The IPX services in accordance with the Terms and Conditions, and associated Schedules for the services detailed below:");
  textBlock(values?.serviceOffering?.details);
  afterTable(GAP_LARGE);
  //5
  section("Charges (Payable by the Customer to Supplier)");
  noteBlock("The Customer will pay Supplier the following Charges in accordance with the term and conditions. The full offer is attached to this orderform.")
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["Non Recurring Charge (NRC)", "Monthly Recurring Charge (MRC)"]],
    body: [[
      safe(normalizePdfText(values?.customerCharges?.nonRecurringCharge)),
      safe(normalizePdfText(values?.customerCharges?.monthlyCharge)),
    ]],
  });
  afterTable(GAP_LARGE);
  //6
  section("Installation Address (PoP Address)");
  textBlock(values?.installationAddress?.popAddress);
  const images = values?.installationAddress?.popAddressImage ?? [];
  if (images.length > 0) {
    const imgObj = images[0];
    if (imgObj?.originalFileName && imgObj?.uniqueFileName) {
      try {
        const fileBlob = await downloadFileStream(
          imgObj.originalFileName,
          imgObj.uniqueFileName
        );
        const blobUrl = URL.createObjectURL(fileBlob);
        const imgData = await toBase64(blobUrl, 1200);
        URL.revokeObjectURL(blobUrl);
        if (imgData?.data) {
          const MAX_IMAGE_WIDTH = CONTENT_W;   // fit page width
          const MAX_IMAGE_HEIGHT = 85;         // max readable height
          // calculate proportional height
          const ratio = imgData.pxH / imgData.pxW;
          let drawWidth = MAX_IMAGE_WIDTH;
          let drawHeight = drawWidth * ratio;
          // if image becomes too tall → scale down
          if (drawHeight > MAX_IMAGE_HEIGHT) {
            drawHeight = MAX_IMAGE_HEIGHT;
            drawWidth = drawHeight / ratio;
          }
          ensureSpace(drawHeight + 10);
          pdf.addImage(
            imgData.data,
            imgData.format || "PNG",
            MARGIN + (CONTENT_W - drawWidth) / 2,
            cursorY,
            drawWidth,
            drawHeight
          );
          cursorY += drawHeight + 10;
        }
      } catch (err) {
        console.error("Failed to render installation image", err);
      }
    }
  }
  cursorY += GAP_MEDIUM;
  //7
  section("Additional Terms");
  textBlock(values?.additionalTerms);
  afterTable(GAP_LARGE);

  /* ===================== SECTION 8 ===================== */
  //8
  section("Vodafone Signatures");
  noteBlock("Agreed by the parties and signed by their duly authorised representatives.")
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["Legal Entity Name", "Registered Number", "Country of Organisation"]],
    body: [[
    safe(values?.vodafoneSignature?.legalEntity),
    safe(values?.vodafoneSignature?.registeredNumber),
    safe(values?.vodafoneSignature?.country),
    ]],
  });
  afterTable(8);

  section("Registered Address");
  textBlock(values?.vodafoneSignature?.registeredAddress);

    ensureSpace(30);
    pdf.setDrawColor(80);
    pdf.text("Signature :", MARGIN, cursorY);
    cursorY += 6;
    pdf.rect(MARGIN, cursorY, CONTENT_W, 18);
    cursorY += 22;

    autoTable(pdf, {
      ...tableBase,
      startY: cursorY,
      head: [["Name", "Title", "Date"]],
      body: [[
      safe(values?.vodafoneSignature?.name),
      safe(values?.vodafoneSignature?.title),
      safe(formatDateInDMY(values?.vodafoneSignature?.date)),
      ]],
    });
  afterTable(GAP_LARGE);

  /* ===================== SECTION 9 ===================== */
  //9
  section("Customer Signature");
  noteBlock("Agreed by the parties and signed by their duly authorised representatives.")
  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["Legal Entity Name", "Registered Number", "Country of Organisation"]],
    body: [[
      safe(values?.customerSignature?.legalEntity),
      safe(values?.customerSignature?.registeredNumber),
      safe(values?.customerSignature?.country),
    ]],
  });
  afterTable(8);

  section("Registered Address");
  textBlock(values?.customerSignature?.registeredAddress);

  ensureSpace(30);
  pdf.text("Signature :", MARGIN, cursorY);
  cursorY += 6;
  pdf.rect(MARGIN, cursorY, CONTENT_W, 18);
  cursorY += 22;

  autoTable(pdf, {
    ...tableBase,
    startY: cursorY,
    head: [["Name", "Title", "Date"]],
    body: [[
      safe(values?.customerSignature?.name),
      safe(values?.customerSignature?.title),
      safe(formatDateInDMY(values?.customerSignature?.date)),
    ]],
  });
  afterTable(GAP_LARGE);

  pdf.save(fileName);
}

export const formatDateInDMY = (unixTimestamp) => {
  if(!unixTimestamp) return ""
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formattedDate = moment
    .unix(unixTimestamp)
    .tz(userTimezone)
    .format("DD MMM YYYY")
  return `${formattedDate} `
}

export function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function formatISOToDDMonYYYY(dateStr) {
  if (!dateStr) return "";
  const [yyyy, mm, dd] = dateStr.split("-");
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  return `${dd} ${months[Number(mm) - 1]} ${yyyy}`;
}